/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import 'lazysizes';
require('browsernizr/test/touchevents');
import { gsap } from 'gsap';
import { debounce } from 'lodash';
import Headroom from 'headroom.js';

import Vue from 'vue';

import router from './router';

// Create event bus.
window.EventBus = new Vue();

const App = new Vue({
    router,
    el: '#app',
    delimiters: ['${', '}'],

    data() {
        return {
        };
    },

    watch: {
    },

    mounted() {
        window.Modernizr = require('browsernizr');
        window.zenscroll = require('zenscroll');

        this.header = document.querySelector('header');
        const headroom  = new Headroom(this.header);
        headroom.init();
        /**
         * Give our fellow console loggers some love!
         */
        console.log('%c Made with 🖤 by 51North: https://51north.nl ', 'background: #fff; color: #000'); // eslint-disable-line
    },

    methods: {
    },

    beforeDestroy() {
    }
});
